<template>
  <div class="live-page">
    <div class="live-header-wrap" v-if="coverInfo && coverInfo.league">
      <div class="league-title">
        <p class="league">{{ coverInfo.league }}</p>
        <p class="time">{{ coverInfo.start_time | formateStartTime }}</p>
        <p>BO{{ coverInfo.bo }}</p>
      </div>
      <div class="team-info">
        <div class="home">
          <span>{{ coverInfo.home_team_name }}</span>
          <img :src="coverInfo.home_logo" @error="onKogTeamLogoError" alt="" />
        </div>
        <div class="score">
          <div class="home">{{ coverInfo.state === 1 ? '-' : coverInfo.home_score }}</div>
          <div class="away">{{ coverInfo.state === 1 ? '-' : coverInfo.away_score }}</div>
        </div>
        <div class="away">
          <img :src="coverInfo.away_logo" @error="onKogTeamLogoError" alt="" />
          <span>{{ coverInfo.away_team_name }}</span>
        </div>
      </div>
      <div class="status">{{ coverInfo.state | stateText }}</div>
    </div>
    <div class="live-player-wrap" v-if="coverInfo && coverInfo.league">
      <LivePlayer @update="chooseTv" :coverInfo="coverInfo" :curTv="curTv" :homeSmallHistory="homeSmallHistory" :awaySmallHistory="awaySmallHistory">
        <template v-slot:gameInfo>
          <LiveGameInfo v-if="gameInfo.home" :coverInfo="coverInfo" :gameInfo="gameInfo" />
        </template>
      </LivePlayer>
    </div>
    <div class="live-data-wrap">
      <div class="live-data">
        <div class="data-tab" v-if="coverInfo && coverInfo.league">
          <div class="tab-item" :class="{'active': activeTab === 0}" @click="changeTab(0)">比赛数据</div>
          <!-- <div class="tab-item" :class="{'active': activeTab === 1}" @click="changeTab(1)">选手数据</div> -->
          <div class="tab-item" :class="{'active': activeTab === 2}" @click="changeTab(2)">对阵数据</div>
          <div class="tab-item" :class="{'active': activeTab === 3}" @click="changeTab(3)">指数数据</div>
        </div>
        <div class="tab-content">
          <component v-if="coverInfo && coverInfo.league"
            :is="currentTabContent"
            :coverInfo="coverInfo"
            :gameInfo="gameInfo"
            :activeGameIdx="activeGameIdx"
            :moreGameData="moreGameData"
            :moreCoverInfo="moreCoverInfo"
            :isDataLoading="isDataLoading"
            :odds="odds"
            :diffInfo="diffInfo"
            :moreDiffInfo="moreDiffInfo"
            @tabChange="tabChange"
            />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import dayjs from "dayjs";
import LivePlayer from '@/components/livePlayer/index.vue'
import LiveGameInfo from '@/components/gameLive/kog/gameInfo.vue'
import GameData from '@/components/gameLive/kog/gameData.vue'
import MemberData from '@/components/gameLive/kog/memberData.vue'
import HistoryData from '@/components/gameLive/kog/historyData.vue'
import OddsData from '@/components/gameLive/kog/oddsData.vue'
import { websocketCommand } from '../../utils/websocket/index.js'

export default {
  name: "KogLive",
  components: {
    LivePlayer,
    LiveGameInfo,
    GameData,
    MemberData,
    HistoryData,
    OddsData
  },
  data() {
    return {
      wsObj: null,
      coverInfo: {},
      gameInfo: {},
      curTv: {
        member_id: 0,
        name: "公共",
        room_user_num: "",
        face: "",
        isnofollow: 1,
        wx_num: "",
        type: 0,
        wx_code: "",
      },
      activeTab: 0,
      activeGameIdx: 0,
      moreGameData: {},
      moreCoverInfo: {},
      diffInfo: {
        diff: ''
      },
      moreDiffInfo: {},
      isDataLoading: false,
      odds: [],
      homeSmallHistory: [],
      awaySmallHistory: [],
      isRequest: [],
      cacheSkills: [],
      lastIdx: 0,
      defaultGamInfo: {
        away: {
          team: {
            "team_name": "",
            "team_logo": "",
            "conditions": 0,
            "game_count": 0,
            "max_game_count": 0,
            "duration": 0,
            "money": 0,
            "kill_count": 0,
            "death_count": 0,
            "assist_count": 0,
            "is_first_blood": 0,
            "is_first_tower": 0,
            "is_first_tyrants": 0,
            "is_first_dominates": 0,
            "is_five_kills": 0,
            "is_ten_kills": 0,
            "tyrants_count": 0,
            "dominates_count": 0,
            "tower_success_count": 0,
            "side": 0,
            "is_win": 0
          },
          ban: [],
          hero: [],
          player: []
        },
        home: {
          team: {
            "team_name": "",
            "team_logo": "",
            "conditions": 0,
            "game_count": 0,
            "max_game_count": 0,
            "duration": 0,
            "money": 0,
            "kill_count": 0,
            "death_count": 0,
            "assist_count": 0,
            "is_first_blood": 0,
            "is_first_tower": 0,
            "is_first_tyrants": 0,
            "is_first_dominates": 0,
            "is_five_kills": 0,
            "is_ten_kills": 0,
            "tyrants_count": 0,
            "dominates_count": 0,
            "tower_success_count": 0,
            "side": 0,
            "is_win": 0
          },
          ban: [],
          hero: [],
          player: []
        }
      }
    };
  },
  filters: {
    formateStartTime(val) {
      return dayjs(val * 1000).format("YYYY-MM-DD HH:mm");
    },
    stateText(val) {
      let txt = "未开赛";
      switch (val) {
        case 1:
          txt = "未开赛";
          break;
        case 2:
          txt = "进行中";
          break;
        case 3:
          txt = "完场";
          break;
        default:
          break;
      }
      return txt;
    }
  },
  computed: {
    currentTabContent() {
      let components = GameData
      switch (this.activeTab) {
        case 0:
          components = GameData
          break;
        case 1:
          components = MemberData
          break;
        case 2:
          components = HistoryData
          break;
        case 3:
          components = OddsData
          break;
        default:
          break;
      }
      return components
    }
  },
  methods: {
    chooseTv (tv) {
      tv.room_id = tv.ws_room_id
      this.curTv = tv
    },
    changeTab (tab) {
      this.activeTab = tab
    },
    tabChange (options) {
      if (options.type === 'gameData') {
        if (!this.moreGameData[options.idx] && options.idx + 1 != this.coverInfo.game_count) {
          this.isDataLoading = true
          this.initCover(options.idx + 1, 'click')
          this.initGameInfo(options.idx + 1, 'click')
        } else {
          this.activeGameIdx = options.idx
          if (options.idx + 1 != this.coverInfo.game_count) {
            this.initGameInfo(options.idx + 1, 'click')
          }
          if (options.idx + 1 == this.coverInfo.game_count && (this.gameInfo.home.team.is_win || this.gameInfo.away.team.is_win)) {
            this.initGameInfo(options.idx + 1, 'update')
          }
        }
      }
    },
    initCover(idx, type) {
      let query = "";
      if (this.$route.query && this.$route.query.id) {
        query = `?tournament_id=${this.$route.query.id}`;
        if (idx) {
          query = `${query}&index=${idx}`;
        }
      } else {
        window.location.href = "/gaming/kog";
        return;
      }
      axios
        .get(COMMOND.NEW_BASE_URL + "v2/kog_cover_info" + query)
        .then((res) => {
          this.pageLoading = false;
          if (res.data.code === 200 && res.data.data && res.data.data.league) {
            if (!idx || idx > this.coverInfo.game_count) {
              this.coverInfo = res.data.data;
            } else {
              this.moreCoverInfo[idx - 1] = res.data.data;
            }
            if (!type) {
              this.activeGameIdx = this.coverInfo.game_count - 1
              this.initGameInfo(idx || this.coverInfo.game_count)
              this.curTv.room_user_num = res.data.data.room_user_num
              this.curTv.roomid = res.data.data.roomid
              this.curTv.room_id = res.data.data.ws_room_id || res.data.data.roomid
              this.curTv.room_notice = res.data.data.room_notice
              // this.initMoneyDiff(res.data.data.battle_id)
            }
            // if (type === 'update' || type === 'click') {
            //   this.initMoneyDiff(res.data.data.battle_id, idx, type)
            // }

            if (type === 'async') {
              this.coverInfo.home_score = res.data.data.home_score
              this.coverInfo.away_score = res.data.data.away_score
              if(idx != this.coverInfo.game_count){
                this.moreCoverInfo[idx - 1] = res.data.data;
              } else {
                this.coverInfo = res.data.data;
              }
            }
            if (res.data.data.tv && res.data.data.tv.length === 1 && !type) {
              res.data.data.tv[0].room_id = res.data.data.tv[0].ws_room_id
              this.curTv = res.data.data.tv[0]
            }
            this.getBattleHistory()
          } else {
            // 数据错误，请求失败
            // window.location.href = '/gaming/lol'
            return;
          }
          if (this.isRequest.length < 1) {
            this.isDataLoading = false
          }
        });
    },
    initGameInfo (idx, type) {
      let query = "";
      if (this.$route.query && this.$route.query.id) {
        query = `?tournament_id=${this.$route.query.id}`;
      }
      if (idx > 1) {
        query = `${query}&index=${idx}`
      }
      this.isRequest.push(1)
      axios
        .get(COMMOND.NEW_BASE_URL + "v2/kog_match_info" + query)
        .then((res) => {
          this.isRequest.shift(1)
          if (res.data.code === 200 && res.data.data && res.data.data.home) {
            if (type === 'click') {
              this.moreGameData[idx - 1] = res.data.data;
              this.activeGameIdx = idx - 1
            }
            if (!type || type === 'update') {
              this.gameInfo = res.data.data;
            }
            if (type === 'async' && res.data.data.home && res.data.data.home.team && res.data.data.home.team.team_id) {
              if(idx != this.coverInfo.game_count){
                this.moreGameData[idx - 1] = res.data.data;
              } else {
                this.gameInfo = res.data.data;
              }
            }
          } else {
            // 数据错误，请求失败
            // window.location.href = '/gaming/lol'
            return;
          }
          this.isDataLoading = false
        });
    },
    initOdds () {
      let query = "";
      if (this.$route.query && this.$route.query.id) {
        query = `?tournament_id=${this.$route.query.id}`;
      }
      axios
        .get(COMMOND.NEW_BASE_URL + "v2/kog_odds" + query)
        .then((res) => {
          if (res.data.code === 200 && res.data.data) {
            this.odds = res.data.data
          } else {
            // 数据错误，请求失败
            // window.location.href = '/gaming/lol'
            return;
          }
          this.isDataLoading = false
        });
    },
    initMoneyDiff (id, idx, type) {
      if (!id) return false
      const query = `?battle_id=${id}`;
      this.isRequest.push(1)
      axios
        .get(COMMOND.NEW_BASE_URL + "v2/kog_diff_info" + query)
        .then((res) => {
          this.isRequest.shift(1)
          if (res.data.code === 200 && res.data.data) {
            if (!idx || type === 'update') {
              this.diffInfo = res.data.data
            } else {
              this.moreDiffInfo[idx - 1] = res.data.data;
            }
          } else {
            // 数据错误，请求失败
            // window.location.href = '/gaming/lol'
            return;
          }
          if (this.isRequest.length < 1) {
            this.isDataLoading = false
          }
        });
    },
    getBattleHistory () {
      let query = "";
      const limit = 5
      if (this.$route.query && this.$route.query.id) {
        query = `?tournament_id=${this.$route.query.id}&home_limit=${limit}&away_limit=${limit}&type=${2}`;
      }
      axios
        .get(COMMOND.NEW_BASE_URL + "v2/kog_battles_history" + query).then(res => {
          if (res.data.code === 200 && res.data.data) {
            this.homeSmallHistory = res.data.data.home.list
            this.awaySmallHistory = res.data.data.away.list
          }
        })
    },
    // 建立连接、发起ws请求，以心跳方式，向服务端发送数据
    createWs () {
      this.wsObj = new WebSocket(this.wsUrl);
      // 若为对象类型，以回调方式发送
      websocketCommand(this.wsObj, 'create', JSON.stringify({'type': 'init', 'task_id': 'esport_kog_matches_' + this.$route.query.id}), this.receiveMsg);
    },
    receiveMsg (msg) {
      console.log('服务端推送', msg);
      if (msg.tournament_id == this.$route.query.id) {
        // 赛事状态
        if (msg.type === 'WsKogState') {
          this.coverInfo.state = msg.result.state
        }
        // 赛比分
        if (msg.type === 'WsKogScore') {
          if (msg.result.home_score) this.coverInfo.home_score = msg.result.home_score
          if (msg.result.away_score) this.coverInfo.away_score = msg.result.away_score
        }
        // 对局时间
        if (msg.type === 'WsKogDate') {
          if (this.coverInfo.game_count == 0 || this.coverInfo.game_count == msg.result.index) {
            if (!(this.gameInfo && this.gameInfo.home && this.gameInfo.home.team)){
              // this.isDataLoading = true
              // this.initCover()
              this.gameInfo = JSON.parse(JSON.stringify(this.defaultGamInfo))
              // this.diffInfo = {
              //   diff: ''
              // }
              this.coverInfo.game_count = msg.result.index
              this.lastIdx = msg.result.index - 1
              this.activeGameIdx = msg.result.index - 1
              this.coverInfo.battle_id = msg.result.battle_id - 0
            } else {
              this.coverInfo.duration = msg.result.duration
              this.coverInfo.battle_id = msg.result.battle_id - 0
            }
          } else {
            this.moreGameData[this.coverInfo.game_count - 1] = this.gameInfo
            this.moreCoverInfo[this.coverInfo.game_count - 1] = this.coverInfo
            // this.moreCoverInfo[this.coverInfo.game_count - 1] = JSON.parse(JSON.stringify(this.diffInfo))
            this.coverInfo.game_count = msg.result.index
            this.coverInfo.battle_id = msg.result.battle_id - 0
            // this.diffInfo = {
            //   diff: ''
            // }
            this.coverInfo.duration = msg.result.duration
            this.gameInfo = JSON.parse(JSON.stringify(this.defaultGamInfo))
          }
        }
        // 团队数据
        if (msg.type === 'WsKogTeam') {
          if (msg.result.home && this.gameInfo.home.team) {
            this.gameInfo.home.team = Object.assign({}, this.gameInfo.home.team, msg.result.home)
          } else {
            this.gameInfo.home.team = msg.result.home
          }
          if (msg.result.away && this.gameInfo.away.team) {
            this.gameInfo.away.team = Object.assign({}, this.gameInfo.away.team, msg.result.away)
          } else {
            this.gameInfo.away.team = msg.result.away
          }
        }
        // 选择英雄
        if (msg.type === 'WsKogHeroPick') {
          if (msg.result.hero_pick && msg.result.hero_pick.length > 0) {
            const pick = msg.result.hero_pick.map(prop => {
              const newPick = {}
              newPick.avatar = prop.hero_avatar
              newPick.name = prop.hero_name
              newPick.id = prop.hero_id
              return newPick
            })
            if (this.gameInfo.home.team && msg.result.team_id == this.gameInfo.home.team.team_id) {
              this.gameInfo.home.hero = pick
            }
            if (this.gameInfo.away.team && msg.result.team_id == this.gameInfo.away.team.team_id) {
              this.gameInfo.away.hero = pick
            }
          }
        }
        // 禁用英雄
        if (msg.type === 'WsKogHeroBan') {
          if (msg.result.hero_pick && msg.result.hero_pick.length > 0) {
            const pick = msg.result.hero_pick.map(prop => {
              const newPick = {}
              newPick.avatar = prop.hero_avatar
              newPick.name = prop.hero_name
              newPick.id = prop.hero_id
              return newPick
            })
            if (msg.result.team_id == this.gameInfo.home.team.team_id) {
              this.gameInfo.home.ban = pick
            }
            if (msg.result.team_id == this.gameInfo.away.team.team_id) {
              this.gameInfo.away.ban = pick
            }
          }
        }
        // 选手数据
        if (msg.type === 'WsKogPlayer' && this.gameInfo.home) {
          if (this.gameInfo.home.team || this.gameInfo.away.team) {
            const isHome = this.gameInfo.home.team.team_id == msg.result.team_id
            if (!this.gameInfo.home.player) {
              this.gameInfo.home.player = []
            }
            if (!this.gameInfo.away.player) {
              this.gameInfo.away.player = []
            }
            const teamPlayers = isHome ? this.gameInfo.home.player : this.gameInfo.away.player
            let playerIdx = teamPlayers.findIndex(player => player.player_id == msg.result.player_id)
            msg.result.money = msg.result.money_count
            if (isHome) {
              if (playerIdx > -1) {
                this.gameInfo.home.player[playerIdx] = Object.assign({}, this.gameInfo.home.player[playerIdx], msg.result)
              } else {
                const skillIdx = this.cacheSkills.findIndex(skill => skill.player_id === msg.result.player_id)
                if (skillIdx > -1) {
                  const skills =  this.cacheSkills[skillIdx].skill.map(skill => {
                    const newSkill = {}
                    newSkill.image = skill.skill_image
                    newSkill.name = skill.skill_name
                    return newSkill
                  })
                  this.cacheSkills.splice(skillIdx, 1)
                  msg.result.skill = skills
                }
                this.gameInfo.home.player.push(msg.result)
              }
            } else {
              if (playerIdx > -1) {
                this.gameInfo.away.player[playerIdx] = Object.assign({}, this.gameInfo.away.player[playerIdx], msg.result)
              } else {
                const skillIdx = this.cacheSkills.findIndex(skill => skill.player_id === msg.result.player_id)
                if (skillIdx > -1) {
                  const skills =  this.cacheSkills[skillIdx].skill.map(skill => {
                    const newSkill = {}
                    newSkill.image = skill.skill_image
                    newSkill.name = skill.skill_name
                    return newSkill
                  })
                  this.cacheSkills.splice(skillIdx, 1)
                  msg.result.skill = skills
                }
                this.gameInfo.away.player.push(msg.result)
              }
            }
          }
        }
        // 装备数据
        if (msg.type === 'WsKogProp') {
          if ((this.gameInfo.home && this.gameInfo.home.player) || (this.gameInfo.away && this.gameInfo.away.player)) {
            const isHome = this.gameInfo.home.team.team_id == msg.result.team_id
            const teamPlayers = isHome ? this.gameInfo.home.player : this.gameInfo.away.player
            let playerIdx = teamPlayers.findIndex(player => player.player_id == msg.result.player_id)
            if (playerIdx > -1) {
              const props =  msg.result.prop.map(prop => {
                const newProp = {}
                newProp.img = prop.prop_image
                newProp.name = prop.prop_name
                return newProp
              })
              if (isHome) {
                this.gameInfo.home.player[playerIdx].prop = props
              } else {
                this.gameInfo.away.player[playerIdx].prop = props
              }
            }
          }
        }
        // 技能
        if (msg.type === 'WsKogSkill') {
          const cacheSkills = JSON.parse(JSON.stringify(this.cacheSkills))
          if (cacheSkills.length > 0) {
            cacheSkills.forEach((skill, idx) => {
              const isHome = this.gameInfo.home.team.team_id == skill.team_id
              const teamPlayers = isHome ? this.gameInfo.home.player : this.gameInfo.away.player
              let playerIdx = teamPlayers.findIndex(player => player.player_id == skill.player_id)
              if (playerIdx > -1) {
                const skills =  skill.skill.map(skill => {
                  const newSkill = {}
                  newSkill.image = skill.skill_image
                  newSkill.name = skill.skill_name
                  return newSkill
                })
                if (isHome) {
                  this.gameInfo.home.player[playerIdx].skill = skills
                } else {
                  this.gameInfo.away.player[playerIdx].skill = skills
                }
                this.cacheSkills.splice(idx, 1)
              }
            })
          }
          if ((this.gameInfo.home.player || this.gameInfo.away.player)) {
            const isHome = this.gameInfo.home.team.team_id == msg.result.team_id
            const teamPlayers = isHome ? this.gameInfo.home.player : this.gameInfo.away.player
            let playerIdx = teamPlayers.findIndex(player => player.player_id == msg.result.player_id)
            if (playerIdx > -1) {
              const skills =  msg.result.skill.map(skill => {
                const newSkill = {}
                newSkill.image = skill.skill_image
                newSkill.name = skill.skill_name
                return newSkill
              })
              if (isHome) {
                this.gameInfo.home.player[playerIdx].skill = skills
              } else {
                this.gameInfo.away.player[playerIdx].skill = skills
              }
            } else {
              this.cacheSkills.push(msg.result)
            }
          }
        }
        // 指数
        if (msg.type === 'WsKogOdds' && this.coverInfo.tournament_id == msg.tournament_id) {
          const newOdds = this.odds.map((i, idx) => {
            const data = msg.result.find(odd => {
              console.warn('WsKogOdds: ',odd.company_id === i.company_id && odd.type === i.type && odd.cover === i.game_count)
              return (odd.company_id === i.company_id && odd.type === i.type && odd.cover === i.game_count)
            })
            if (data) {
              data.now_score = data.score
              data.now_small_score = data.small_score
              delete data.score
              delete data.small_score
            }
            const newOdd = {
              ...i, ...(data || {})
            }
            return newOdd
          })
          this.odds = newOdds
        }
        // // 经济差
        // if (msg.type === 'WsLolEconomyDiff') {
        //   if (this.coverInfo.tournament_id == msg.result.tournament_id && this.coverInfo.battle_id == msg.result.battle_id && msg.result.content) {
        //     this.diffInfo = {
        //       diff: msg.result.content
        //     }
        //   }
        // }
        // 小局结束刷新数据
        if (msg.type === 'WsKogBattle') {
          if (this.coverInfo.tournament_id == msg.tournament_id) {
            this.initGameInfo(msg.result.index, 'async')
            this.initCover(msg.result.index, 'async')
          }
        }
      }
    }
  },
  mounted() {
    if (!(this.$route.query && this.$route.query.id)) {
      window.location.href = "/gaming/lol";
      return;
    }
    if (this.$route.query && this.$route.query.tab) {
      if ([0,2,3].includes(Number(this.$route.query.tab))) {
        this.activeTab = Number(this.$route.query.tab) || 0
      }
    }
    this.initCover();
    this.initOdds()
    this.createWs()
  },
  beforeDestroy () {
    websocketCommand(this.wsObj,'close');
    this.wsObj=null;
  }
};
</script>

<style lang="less" scoped>
.live-page {
  min-height: calc(100vh - 60px);
}
.live-header-wrap {
  width: 1020px;
  height: 205px;
  margin: 0 auto 0;
  background: #fff;
  padding-top: 28px;
  .league-title {
    display: flex;
    gap: 20px;
    justify-content: center;
    font-size: 18px;
    line-height: 24px;
  }
  .team-info {
    display: flex;
    gap: 104px;
    justify-content: center;
    margin-top: 15px;
    margin-bottom: 10px;
    > .home,
    > .away {
      display: flex;
      gap: 5px;
      img {
        width: 82px;
        height: 82px;
      }
      span {
        font-size: 34px;
        line-height: 82px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        width: 242px;
      }
    }
    > .home {
      span {
        text-align: right;
      }
    }
    .score {
      display: flex;
      gap: 30px;
      .home,
      .away {
        width: 62px;
        height: 74px;
        line-height: 74px;
        background: #ffffff;
        box-shadow: 0px 1px 10px 0px rgba(117, 34, 34, 0.25);
        font-size: 34px;
        text-align: center;
        border-radius: 5px;
      }
    }
  }
  .status {
    text-align: center;
    font-size: 18px;
    line-height: 24px;
    color: #e65668;
  }
}
.live-player-wrap {
  background: #fbfbff;
  padding-top: 20px;
  .live-player {
    width: 1020px;
    margin: 0 auto;
  }
}
.live-data-wrap {
  background: #fbfbff;
  .live-data {
    width: 1020px;
    margin: 0 auto;
    padding-top: 20px;
    padding-bottom: 55px;
    .data-tab {
      display: flex;
      height: 50px;
      background: #fff;
      border-radius: 5px;
      .tab-item {
        flex: 1;
        text-align: center;
        line-height: 50px;
        color: #13161B;
        font-size: 24px;
        cursor: pointer;
        &.active {
          color: #E65668;
        }
      }
    }
    .tab-content {
      margin-top: 20px;
    }
  }
}
</style>
